module.exports = __webpack_public_path__ + "0c0d83679f842614fec4e480ea5713eb.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/animals/turtle.svg
// module id = 96
// module chunks = 0